import CommonClass from './commonclass'
import config from '../config/index'
import en from './en'
import mo from './mo'

const  Common = {

    getLabel: (msg,lng='en')=>{ 
        if(config.lng=="mo"){
            return (mo[msg]!=null) ? mo[msg] : msg
        }else {
            return (en[msg]!=null) ? en[msg] : msg
        }  
       //return english.message;
    },
    getCim : 'cim',
    getPim : 'pim',
    getCurrency: (key)=>{
        let c = {mn:'₮', doller: '$', yuan:' ¥'}
        return c[key]
    },
    getPaymentStatus: (key)=>{
        if(key=='0'){
            return 'Pending';
        }else if(key=='2'){
            return 'Uploaded';
        }else if(key=='1'){
            return 'Paid';
        }else{
          return key
        }
    },
    getOrderStatus: (key)=>{
        if(key=='placed'){
            return Common.getLabel('Order_Placed');
        }else if(key=='processing'){
            return Common.getLabel('Preparing_For_Dispatch');
        }else if(key=='shipped'){
            return Common.getLabel('Out_for_Delivery');
        }else if(key=='completed'){
            return Common.getLabel('Delivered');
        }else{
          return key
        }
    },
    getdbNames : CommonClass,

    getBuysellcatIds: (id) =>{
        return [41].includes(Number(id))
    } 
}

export default Common;